import { connect } from 'react-redux';
import AgreementsList from './agreements-list';

function mapStateToProps (state) {
  return {
    dateFilter: state.filters.dateFilter,
    user: state.user
  };
};

export default connect(mapStateToProps)(AgreementsList);



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/agreements/agreements-list-container.js
 **/